<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="宿舍信息"
      id-key="DormitoryId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="isCreate?api.add:api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="宿舍地址" prop="DormitoryAddr">
              <el-input size="mini" v-model="data.DormitoryAddr" placeholder="请填写教师编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:12">
            <el-form-item label="容纳人数" prop="Capacity">
              <el-input size="mini" v-model="data.Capacity" type="number" placeholder="请填写容纳人数"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:16" v-if="isCreate">
            <el-radio v-model="radio" :label="true" style="margin:0 14px 20px 5px;">单房号</el-radio>
            <el-input size="mini" v-model="data.DormitoryNumber" :disabled="!radio" placeholder="请填写房号" :style="isMB?'width:auto;':'width:185px;'"></el-input>
          </el-col>
          <el-col :span="isMB?24:12" v-else>
            <el-form-item label="单房号" prop="DormitoryNumber">
              <el-input size="mini" v-model="data.DormitoryNumber" placeholder="请填写房号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:24" v-if="isCreate">
            <el-radio v-model="radio" :label="false" style="margin:0 10px 0 5px;">批量房号</el-radio>
            楼层
            <el-input size="mini" v-model="data.StartFloor" type="number" :disabled="radio" style="width:50px;margin: 0 5px;"></el-input> - 
            <el-input size="mini" v-model="data.EndFloor" type="number" :disabled="radio" style="width:50px;margin: 0 5px;"></el-input>
            <br v-if="isMB"><span style="margin: 8px;">每层房间数</span>
            <el-input size="mini" v-model="data.RoomCount" :disabled="radio==1" placeholder="请填写房间数" :style="isMB?'margin-top:10px;width:185px;':'width:185px;'"></el-input>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  watch: {
    radio(nv) {
      if(nv) {
        this.data.StartFloor = null
        this.data.EndFloor = null
        this.data.RoomCount = null
      } else {
        this.data.DormitoryNumber = ""
      }
    }
  },
  data() {
    return {
      data: {
        DormitoryId: 0,
        DormitoryAddr: "",
        DormitoryNumber: "",
        Capacity: null,
        StartFloor: 1,
        EndFloor: 1,
        RoomCount: 1,
      },
      api: require("@/api/lo/dorm").default,
      isMB: this.$store.state.isMB,
      gradeList: [],
      radio: true,
      isCreate: true,
      rules: {
        DormitoryAddr: [{ required: true, message: "请填写宿舍地址" }],
        Capacity: [{ required: true, message: "请填写容纳人数" }],
        DormitoryNumber: [{ required: !this.isCreate, message: "请填写单房号" }]
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.isCreate = true
    },
    onEditOpened() {
      this.isCreate = false
    },
    onBeforeSave() {
      if(!(this.data.Capacity > 0 && this.data.Capacity %1 == 0)) {
        this.$message.error("容纳人数需为正整数")
        return false
      }
      if(this.radio) {
        if(!this.data.DormitoryNumber) {
          this.$message.error("请填写单房号")
          return false
        }
      } else {
        if(!(this.data.StartFloor >= 0 && this.data.StartFloor %1 == 0)) {
          this.$message.error("楼层需为正整数")
          return false
        }
        if(!(this.data.EndFloor >= this.data.StartFloor && this.data.EndFloor %1 == 0)) {
          this.$message.error("请填写")
          return false
        }
        if(!(this.data.RoomCount > 0 && this.data.RoomCount %1 == 0)) {
          this.$message.error("房间数需为正整数")
          return false
        }
      }
    },
  },
};
</script>
<style lang="scss">
</style>